const fetchCompanies = (state) => {
  state.isLoading = true
  state.error = null
  state.companies = []
}

const fetchCompaniesSuccess = (state, companies) => {
  state.isLoading = false
  state.error = null
  state.companies = companies
}

const fetchCompaniesError = (state, error) => {
  state.isLoading = false
  state.error = error
  state.companies = []
}

const fetchCompany = (state) => {
  state.isLoading = true
  state.error = null
  state.company = null
}

const fetchCompanySuccess = (state, company) => {
  state.isLoading = false
  state.error = null
  state.company = company
}

const fetchCompanyError = (state, error) => {
  state.isLoading = false
  state.error = error
  state.company = null
}

const updateCompanySuccess = (state, company) => {
  state.isLoading = false
  state.error = null
  state.company = company
}

const updateCompanyError = (state, error) => {
  state.isLoading = false
  state.error = error
}

const addCompany = (state) => {
  state.formIsSubmitted = true
  state.error = null
}

const addCompanySuccess = (state) => {
  state.formIsSubmitted = false
  state.error = null
  state.form = {}
}

const addCompanyError = (state, error) => {
  state.formIsSubmitted = false
  state.error = error
}

export default {
  fetchCompanies,
  fetchCompaniesSuccess,
  fetchCompaniesError,
  fetchCompany,
  fetchCompanyError,
  fetchCompanySuccess,
  updateCompanyError,
  updateCompanySuccess,
  addCompany,
  addCompanyError,
  addCompanySuccess,
}
